import { useEffect } from 'react';
import { Grid } from '@gusto/workbench';
import useCompanyLead from 'packages/signup/components/signupForm/use_company_lead';
import LoadingSkeleton from 'packages/signup/components/explore/embeddedLeadForm/LoadingSkeleton';
import { isOrganicPage, isReferrals } from 'helpers/visitor_page_helper';
import plantShopEmployeesSvg from 'signupV2/plant_shop_employees.svg';
import { useSignupContext } from 'packages/signup/components/signupProvider';
import GoogleSignupCta from 'packages/signup/components/signupForm/googleSignupCta';
import FormFooter from 'packages/signup/components/signupForm/formFooter';
import CompanySignupForm from 'packages/signup/components/signupForm/form';
import trackLeadFormWithPasswordLoaded from 'packages/signup/analytics/trackLeadFormWithPasswordLoaded';
import useResponsive from 'packages/signup/helpers/useResponsive';

export default function SignupForm() {
  const { loading, fromSSO, ssoProvider, companyLead } = useCompanyLead();
  const { submissionOrigin } = useSignupContext();

  useEffect(() => {
    // Scroll to the top of the page when the form loads, when user is coming from the tofu survey, the page is scrolled down, so we need to scroll up
    window?.scrollTo(0, 0);
    trackLeadFormWithPasswordLoaded();
  }, []);
  const { isTablet } = useResponsive();

  if (loading) return <LoadingSkeleton />;

  const showCustomHeader = ['BdLandingPage', 'PaidLandingPage'].includes(
    submissionOrigin as string
  );

  return (
    <Grid
      autoRows="max-content"
      maxWidth={632}
      paddingBottom={0}
      rowGap={3}
      width="100%"
      className="signup-form-grid"
    >
      {showCustomHeader && (
        <p className="text-center">
          <strong>Nice!</strong> We could be a great fit for your business.
        </p>
      )}
      {!fromSSO && (
        <GoogleSignupCta
          googleSignupBaseUrl="/google_sso/homepage_survey_signup/new"
          googleButtonLabel="Sign up with Google"
        />
      )}
      <CompanySignupForm companyLead={companyLead} fromSSO={fromSSO} ssoProvider={ssoProvider} />
      <div
        className={`${isOrganicPage() || isReferrals() ? 'sign-up-form-organic' : 'sign-up-form'}`}
      >
        <FormFooter />
        {(isOrganicPage() || isReferrals()) && !isTablet && (
          <img
            className="layout-illustration-mobile"
            alt="Happy employees in a plant shop"
            src={plantShopEmployeesSvg}
          />
        )}
      </div>
    </Grid>
  );
}
